
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1fOao", function(module, exports) {

$parcel$export(module.exports, "useAutomationMenu", () => $e1d1978ef947919e$export$9e222d3b7ca4dc6f);
$parcel$export(module.exports, "ConfluenceManualRulesContainer", () => $e1d1978ef947919e$export$235166e539b0088a);
// This is another layer on top of the AFE ManualRulesContainer.
// It is necessary that this container wraps the entire "automation" component and not nested. Else the user input form will not render correctly.
// This container provides an automation context to all children components through the useAutomationMenu hook.

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $bHPHO = parcelRequire("bHPHO");

var $0B4xj = parcelRequire("0B4xj");

var $dIouf = parcelRequire("dIouf");

var $7aRa9 = parcelRequire("7aRa9");

var $bQm3c = parcelRequire("bQm3c");

var $awcJz = parcelRequire("awcJz");

var $71D5r = parcelRequire("71D5r");
const $e1d1978ef947919e$var$AutomationMenuContext = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $e1d1978ef947919e$var$AutomationMenuProvider = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e1d1978ef947919e$var$AutomationMenuContext.Provider, {
        value: value
    }, children);
};
const $e1d1978ef947919e$export$9e222d3b7ca4dc6f = ()=>{
    const context = (0, $gwFzn.useContext)($e1d1978ef947919e$var$AutomationMenuContext);
    if (context === undefined) throw new Error('useAutomationMenu must be used within a AutomationMenuProvider');
    return context;
};
const $e1d1978ef947919e$var$i18n = (0, $2nPZH.defineMessages)({
    ruleInvocationSuccessTitle: {
        id: "automation-menu.flag.invocation.success.title",
        defaultMessage: "Your automation is in progress"
    },
    ruleInvocationFailureTitle: {
        id: "automation-menu.flag.invocation.failure.title",
        defaultMessage: "Oops we ran into a problem"
    },
    ruleInvocationFailureDescription: {
        id: "automation-menu.flag.invocation.failure.description",
        defaultMessage: "There was a problem and we couldn\u2019t run the automation"
    }
});
const $e1d1978ef947919e$export$235166e539b0088a = (0, $7aRa9.withFlags)(({ flags: flags, analyticsSource: analyticsSource, aris: aris, spaceKey: spaceKey, children: children, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone, singleSpace: singleSpace })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const mappedEnvironment = (0, $71D5r.mapEnv)(environment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $0B4xj.ManualRulesContainer), {
        env: mappedEnvironment,
        site: (0, $bHPHO.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString(),
        query: {
            //if all pages are in same space, we only need one ari
            objects: singleSpace ? aris.slice(0, 1).map(String) : aris.map(String)
        },
        onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone,
        onRuleInvocationSuccess: ()=>{
            flags.hideFlag('automation-manual-trigger-execution-queued-flag').then(()=>flags.showInfoFlag({
                    id: 'automation-manual-trigger-execution-finished-flag',
                    title: formatMessage($e1d1978ef947919e$var$i18n.ruleInvocationSuccessTitle),
                    isAutoDismiss: true
                }));
        },
        onRuleInvocationFailure: ()=>{
            flags.hideFlag('automation-manual-trigger-execution-queued-flag').then(()=>flags.showErrorFlag({
                    id: 'automation-manual-trigger-execution-finished-flag',
                    title: formatMessage($e1d1978ef947919e$var$i18n.ruleInvocationFailureTitle),
                    description: formatMessage($e1d1978ef947919e$var$i18n.ruleInvocationFailureDescription),
                    isAutoDismiss: true
                }));
        }
    }, (props)=>{
        const baseAutomationUrl = (0, $awcJz.getBaseAutomationUrl)({
            spaceKey: spaceKey
        });
        const contextValue = {
            ...props,
            analyticsSource: analyticsSource,
            aris: aris,
            baseAutomationUrl: baseAutomationUrl,
            spaceKey: spaceKey
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            attribution: (0, $dIouf.Attribution).AUTOMATION_FOR_CONFLUENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e1d1978ef947919e$var$AutomationMenuProvider, {
            value: contextValue
        }, children()));
    });
});

});
parcelRegister("0B4xj", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $3dc9b564e50a41bb$export$eb0a81e78d942dba);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $6xdDU = parcelRequire("6xdDU");

var $9Begw = parcelRequire("9Begw");

var $fpK0a = parcelRequire("fpK0a");
const $3dc9b564e50a41bb$export$96513fc6544cb4e5 = (env, site, query)=>{
    const [initialised, setInitialised] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(null);
    const [rules, setRules] = (0, $gwFzn.useState)([]);
    const transformRules = (ruleResponse)=>{
        const rulesUnsorted = Object.values(ruleResponse);
        return rulesUnsorted.sort((rule1, rule2)=>rule1.name.localeCompare(rule2.name));
    };
    const triggerFetch = async ()=>{
        setInitialised(false);
        try {
            const fetchedRules = await (0, $9Begw.searchManuallyTriggeredRules)(env, site, query);
            setError(null);
            setRules(transformRules(fetchedRules));
        } catch (e) {
            setError(e);
            setRules([]);
        } finally{
            setInitialised(true);
        }
    };
    return [
        triggerFetch,
        initialised,
        error,
        rules
    ];
};
const $3dc9b564e50a41bb$export$eb0a81e78d942dba = (props)=>{
    (0, $RUXAI.di)((0, $6xdDU.default), (0, $fpK0a.default), (0, $9Begw.invokeManuallyTriggeredRule), $3dc9b564e50a41bb$export$96513fc6544cb4e5, (0, $gwFzn.useMemo), (0, $gwFzn.useState));
    const { env: env, site: site, query: query, children: children, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed, onRuleInvocationLifecycleStarted: onRuleInvocationLifecycleStarted, onRuleInvocationSuccess: onRuleInvocationSuccess, onRuleInvocationFailure: onRuleInvocationFailure, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone } = props;
    // Initial data loading state
    const [triggerFetch, initialised, error, rules] = $3dc9b564e50a41bb$export$96513fc6544cb4e5(env, site, query);
    // We store a rule in state here if and only if a rule has user inputs, and thus
    // we need to preserve state while the input dialog is open.
    const [selectedRule, setSelectedRule] = (0, $gwFzn.useState)(null);
    const clearSelectedRule = ()=>{
        setSelectedRule(null);
    };
    // Value set when a rule is invoking, either from the dialog or without dialog
    const [invokingRuleId, setInvokingRuleId] = (0, $gwFzn.useState)(null);
    // Memoized projection of rules by id
    const rulesById = (0, $gwFzn.useMemo)(()=>rules.reduce((acc, rule)=>({
                // eslint-disable-next-line
                ...acc,
                [rule.id]: rule
            }), {}), [
        rules
    ]);
    const getRule = (id)=>rulesById[id];
    const ruleHasInputs = (rule)=>rule?.userInputPrompts?.length > 0;
    const INVOCATIONS = 'invocations';
    const SUCCESS = 'SUCCESS';
    const getFailedObjects = (response)=>Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] !== SUCCESS);
    const getSuccessfulObjects = (response)=>Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] === SUCCESS);
    const handleInvocationFailure = (ruleId, successfulObjects, failedObjects)=>{
        if (onRuleInvocationFailure) onRuleInvocationFailure(ruleId, successfulObjects, failedObjects);
    };
    const invokeRule = async (ruleId, objects, userInputs)=>{
        const rule = getRule(ruleId);
        if (rule) {
            setInvokingRuleId(ruleId);
            try {
                if (onRuleInvocationLifecycleStarted) onRuleInvocationLifecycleStarted(ruleId, objects, userInputs);
                const response = await (0, $9Begw.invokeManuallyTriggeredRule)(env, site, ruleId, objects, userInputs);
                const failedObjects = getFailedObjects(response);
                setInvokingRuleId(null);
                if (failedObjects.length === 0) {
                    if (onRuleInvocationSuccess) onRuleInvocationSuccess(ruleId, objects);
                } else {
                    const successfulObjects = getSuccessfulObjects(response);
                    handleInvocationFailure(ruleId, successfulObjects, failedObjects);
                }
            } catch (e) {
                handleInvocationFailure(ruleId, [], objects);
                setInvokingRuleId(null);
            }
        } else handleInvocationFailure(ruleId, [], objects);
        clearSelectedRule();
        if (onRuleInvocationLifecycleDone) onRuleInvocationLifecycleDone(ruleId, objects);
    };
    const invokeRuleOrShowDialog = (ruleId, objects)=>{
        const rule = getRule(ruleId);
        if (!rule) return handleInvocationFailure(ruleId, [], objects);
        if (ruleHasInputs(rule)) setSelectedRule({
            rule: rule,
            objects: objects
        });
        else invokeRule(ruleId, objects);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            children({
                triggerFetch: triggerFetch,
                initialised: initialised,
                error: error,
                rules: rules,
                invokingRuleId: invokingRuleId,
                invokeRuleOrShowDialog: invokeRuleOrShowDialog
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
                children: selectedRule && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fpK0a.default), {
                    onInputsModalOpened: onInputsModalOpened,
                    onInputsModalClosed: onInputsModalClosed,
                    clearSelectedRule: clearSelectedRule,
                    selectedRule: selectedRule,
                    invokeRule: invokeRule
                })
            })
        ]
    });
};

});
parcelRegister("fpK0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $be85f4683a10666c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $ccHMk = parcelRequire("ccHMk");

var $fzqvY = parcelRequire("fzqvY");
var $gQhRa = parcelRequire("gQhRa");
var $3eD0p = parcelRequire("3eD0p");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $iB0Jl = parcelRequire("iB0Jl");

var $cSnD1 = parcelRequire("cSnD1");

var $jYpUz = parcelRequire("jYpUz");

var $js9mw = parcelRequire("js9mw");

var $eXP4H = parcelRequire("eXP4H");

var $ag8oA = parcelRequire("ag8oA");

var $7jE9X = parcelRequire("7jE9X");
const $be85f4683a10666c$export$a3f697c029ab2691 = (props)=>{
    (0, $RUXAI.di)((0, $jYpUz.default), (0, $ccHMk.default), (0, $gQhRa.ErrorMessage), (0, $fzqvY.default), (0, $3eD0p.default), (0, $ekolh.default), (0, $1DHa6.default), (0, $8o1lj.default), (0, $9ot3w.default), (0, $d8eRd.default), (0, $js9mw.default), (0, $ag8oA.default), (0, $7jE9X.default));
    const { selectedRule: selectedRule, clearSelectedRule: clearSelectedRule, invokeRule: invokeRule, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed } = props;
    const { rule: rule, objects: objects } = selectedRule;
    const { userInputPrompts: userInputPrompts } = rule;
    const getTypeOfInput = (key, prompts)=>prompts.find(({ variableName: variableName })=>variableName === key)?.inputType;
    const generateInputValue = (inputType, data)=>{
        switch(inputType){
            case (0, $cSnD1.UserInputType).DROPDOWN:
                return {
                    inputType: inputType,
                    value: data ? data.value : ''
                };
            case (0, $cSnD1.UserInputType).NUMBER:
                return {
                    inputType: inputType,
                    value: Number(data)
                };
            default:
                return {
                    inputType: inputType,
                    value: data
                };
        }
    };
    const handleSubmit = (data)=>{
        const output = Object.entries(data).reduce((acc, [key, value])=>{
            const inputType = getTypeOfInput(key, userInputPrompts);
            if (!inputType) return acc;
            acc[key] = generateInputValue(inputType, value);
            return acc;
        }, {});
        return invokeRule(rule.id, objects, output);
    };
    const handleOpen = ()=>{
        if (onInputsModalOpened) onInputsModalOpened();
    };
    const handleClose = ()=>{
        clearSelectedRule();
        if (onInputsModalClosed) onInputsModalClosed();
    };
    const generateUserInputForm = (inputPrompt)=>{
        switch(inputPrompt.inputType){
            case (0, $cSnD1.UserInputType).TEXT:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7jE9X.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $cSnD1.UserInputType).NUMBER:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $js9mw.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $cSnD1.UserInputType).DROPDOWN:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ag8oA.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $cSnD1.UserInputType).BOOLEAN:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jYpUz.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $cSnD1.UserInputType).PARAGRAPH:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eXP4H.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            default:
                return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                            children: (0, $iB0Jl.default).errorInputTypeIsNotSupported.defaultMessage
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("br", {})
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ekolh.default), {
        "data-testid": "automation-platform.ui.manual-rules-container.manual-triggers-form.modal",
        onClose: handleClose,
        onOpenComplete: handleOpen,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fzqvY.default), {
            onSubmit: handleSubmit,
            children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9ot3w.default), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d8eRd.default), {
                                children: rule.name
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1DHa6.default), {
                            children: [
                                (0, $iB0Jl.default).inputRequiredForAction.defaultMessage,
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3eD0p.default), {
                                    children: userInputPrompts.map(generateUserInputForm)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $8o1lj.default), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                                    appearance: "subtle",
                                    onClick: handleClose,
                                    isDisabled: submitting,
                                    children: (0, $iB0Jl.default).cancelButtonTitle.defaultMessage
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isLoading: submitting,
                                    autoFocus: true,
                                    children: (0, $iB0Jl.default).continueButtonTitle.defaultMessage
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
var $be85f4683a10666c$export$2e2bcd8739ae039 = $be85f4683a10666c$export$a3f697c029ab2691;

});
parcelRegister("iB0Jl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58bb86fd209f1a14$export$2e2bcd8739ae039);
const $58bb86fd209f1a14$var$messages = {
    successFlag: {
        id: 'automation-platform.common.success-flag',
        defaultMessage: 'Your automation is in progress',
        description: 'Text for a success flag when an automation rule has been triggered'
    },
    failureFlagTitle: {
        id: 'automation-platform.common.failure-flag-title',
        defaultMessage: 'Oops we ran into a problem',
        description: 'Title for an error flag when an automation rule failed to be triggered'
    },
    failureFlagDescription: {
        id: 'automation-platform.common.failure-flag-description',
        defaultMessage: "There was a problem and we couldn't run the automation '{0}'",
        description: 'Description for an error flag when an automation rule failed to be triggered'
    },
    partialFailureFlagDescription: {
        id: 'automation-platform.common.partial-failure-flag-description',
        defaultMessage: "Couldn't run the automation against issues {0}, please ensure you have permission to view these issues",
        description: 'Description for an error flag when some issues failed to invoke because user does not have view permission'
    },
    errorInputMustNotBeEmpty: {
        id: 'automation-platform.common.error-input-must-not-be-empty',
        defaultMessage: 'Input must not be empty',
        description: 'The error message to show the value of a required field is empty'
    },
    errorInputCharacterLimitReached: {
        id: 'automation-platform.common.error-input-character-limit-reached',
        defaultMessage: 'Provided value exceeds the character limit for the field.',
        description: 'The error message to show that the character limit has been reached for the field'
    },
    inputRequiredForAction: {
        id: 'automation-platform.common.input-required-for-action',
        defaultMessage: 'Your input is required to complete this action',
        description: 'The title of the modal for user inputs'
    },
    errorInputTypeIsNotSupported: {
        id: 'automation-platform.common.error-input-type-is-not-supported',
        defaultMessage: 'Input type not supported yet',
        description: 'The error message to show when the type of user input is not recognised'
    },
    errorValueIsNotValidNumber: {
        id: 'automation-platform.common.error-value-is-not-valid-number',
        defaultMessage: 'The value is not a valid number',
        description: 'The error message for when the type of user input is number but the value is not a valid number'
    },
    cancelButtonTitle: {
        id: 'automation-platform.common.cancel-button-title',
        defaultMessage: 'Cancel',
        description: 'The cancel button title'
    },
    continueButtonTitle: {
        id: 'automation-platform.common.continue-button-title',
        defaultMessage: 'Continue',
        description: 'The continue button title'
    }
};
var $58bb86fd209f1a14$export$2e2bcd8739ae039 = $58bb86fd209f1a14$var$messages;

});

parcelRegister("cSnD1", function(module, exports) {

$parcel$export(module.exports, "UserInputType", () => $2e786fc3a725eb31$export$955ccc93b55d5904);
var $2e786fc3a725eb31$export$955ccc93b55d5904 = /*#__PURE__*/ function(UserInputType) {
    UserInputType["NUMBER"] = "NUMBER";
    UserInputType["TEXT"] = "TEXT";
    UserInputType["BOOLEAN"] = "BOOLEAN";
    UserInputType["DROPDOWN"] = "DROPDOWN";
    UserInputType["PARAGRAPH"] = "PARAGRAPH";
    return UserInputType;
}({});
const $2e786fc3a725eb31$export$4b79f735ed858abe = 'business';
const $2e786fc3a725eb31$export$417275bac62d38d2 = 'software';
const $2e786fc3a725eb31$export$9c9c9eaf8c092006 = 'service_desk';
const $2e786fc3a725eb31$export$e9fe9a39cc7f5103 = 'product_discovery';
const $2e786fc3a725eb31$export$e9c56aa3b027d98f = 'customer_service';

});

parcelRegister("jYpUz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d57249674e1928bc$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $7gpC4 = parcelRequire("7gpC4");

var $6rSJC = parcelRequire("6rSJC");
const $d57249674e1928bc$var$BooleanInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $RUXAI.di)((0, $7gpC4.default), (0, $6rSJC.default));
    const { variableName: variableName, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6rSJC.default), {
        name: variableName,
        defaultIsChecked: defaultValue || false,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
                ...fieldProps,
                label: displayName
            })
    });
};
var $d57249674e1928bc$export$2e2bcd8739ae039 = $d57249674e1928bc$var$BooleanInputPrompt;

});

parcelRegister("js9mw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ca042666076337$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");

var $4noo5 = parcelRequire("4noo5");

var $iB0Jl = parcelRequire("iB0Jl");
var $b9ca042666076337$export$b8e9cd941e8016ac = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["INVALID_NUMBER"] = "INVALID_NUMBER";
    return Errors;
}({});
const $b9ca042666076337$export$c6cbc3bbef9e5a54 = (isRequired, value)=>{
    if (isRequired && !value) return "EMPTY";
    if (value && Number.isNaN(Number(value))) return "INVALID_NUMBER";
    return undefined;
};
const $b9ca042666076337$var$NumberInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $RUXAI.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $4noo5.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const generateErrorMessage = (error)=>{
        switch(error){
            case "EMPTY":
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                    children: (0, $iB0Jl.default).errorInputMustNotBeEmpty.defaultMessage
                });
            case "INVALID_NUMBER":
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                    children: (0, $iB0Jl.default).errorValueIsNotValidNumber.defaultMessage
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
        "aria-required": required,
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: (value)=>$b9ca042666076337$export$c6cbc3bbef9e5a54(required, value),
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4noo5.default), {
                        ...fieldProps
                    }),
                    generateErrorMessage(error)
                ]
            })
    }, variableName);
};
var $b9ca042666076337$export$2e2bcd8739ae039 = $b9ca042666076337$var$NumberInputPrompt;

});

parcelRegister("eXP4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $33686cdbcd59ec20$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");

var $9EtP6 = parcelRequire("9EtP6");

var $iB0Jl = parcelRequire("iB0Jl");
var $33686cdbcd59ec20$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["CHARACTER_LIMIT"] = "CHARACTER_LIMIT";
    return Errors;
}($33686cdbcd59ec20$var$Errors || {});
const $33686cdbcd59ec20$var$MAX_PARAGRAPH_CHARACTER_LIMIT = 5000;
const $33686cdbcd59ec20$var$ParagraphInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $RUXAI.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $9EtP6.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        if (value && value?.trim().length === 0) return "EMPTY";
        if (value && value.length > $33686cdbcd59ec20$var$MAX_PARAGRAPH_CHARACTER_LIMIT) return "CHARACTER_LIMIT";
        return undefined;
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9EtP6.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                        children: (0, $iB0Jl.default).errorInputMustNotBeEmpty.defaultMessage
                    }),
                    error === "CHARACTER_LIMIT" && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                        children: (0, $iB0Jl.default).errorInputCharacterLimitReached.defaultMessage
                    })
                ]
            })
    });
};
var $33686cdbcd59ec20$export$2e2bcd8739ae039 = $33686cdbcd59ec20$var$ParagraphInputPrompt;

});

parcelRegister("ag8oA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d969a0131b921f31$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");

var $2gD2K = parcelRequire("2gD2K");

var $iB0Jl = parcelRequire("iB0Jl");
var $d969a0131b921f31$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($d969a0131b921f31$var$Errors || {});
const $d969a0131b921f31$var$SelectInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $RUXAI.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $2gD2K.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        return undefined;
    };
    const selectOptions = defaultValue.map((value)=>({
            label: value,
            value: value
        }));
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
        name: variableName,
        label: displayName,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2gD2K.default), {
                        isClearable: true,
                        isSearchable: true,
                        options: selectOptions,
                        menuPosition: "fixed",
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                        children: (0, $iB0Jl.default).errorInputMustNotBeEmpty.defaultMessage
                    })
                ]
            })
    });
};
var $d969a0131b921f31$export$2e2bcd8739ae039 = $d969a0131b921f31$var$SelectInputPrompt;

});

parcelRegister("7jE9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4484a0ac3321a8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");

var $4noo5 = parcelRequire("4noo5");

var $iB0Jl = parcelRequire("iB0Jl");
var $1c4484a0ac3321a8$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($1c4484a0ac3321a8$var$Errors || {});
const $1c4484a0ac3321a8$var$TextInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $RUXAI.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $4noo5.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>required && !value ? "EMPTY" : undefined;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4noo5.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                        children: (0, $iB0Jl.default).errorInputMustNotBeEmpty.defaultMessage
                    })
                ]
            })
    });
};
var $1c4484a0ac3321a8$export$2e2bcd8739ae039 = $1c4484a0ac3321a8$var$TextInputPrompt;

});



parcelRegister("awcJz", function(module, exports) {

$parcel$export(module.exports, "getBaseAutomationUrl", () => $4bac0f7515b59602$export$8e479e490e1e69bc);
const $4bac0f7515b59602$export$8e479e490e1e69bc = ({ spaceKey: spaceKey })=>{
    return `/wiki/spaces/${spaceKey}/settings/automation`;
};

});


parcelRegister("kT5zt", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $f8bed93993cee5a0$export$8f31e4c4a37b8e9c);
/* Skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f8bed93993cee5a0$var$AutomationSkeletonContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt4x7n9",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$SkeletonContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18s813su _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$SkeletonIcon = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rkov77o _19it1lf1 _1bsbpxbi _4t3ipxbi _1e0c1o8l _bfhk1r31 _tzy4nh7s",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$MenuIcon = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f8bed93993cee5a0$var$SkeletonText = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb13sl _4t3ipxbi _19pk1b66 _18u0utpp _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkn82g _1itkfzvv _12vemgnk",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$SkeletonLine = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$MenuIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$SkeletonIcon, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$SkeletonText, null));
const $f8bed93993cee5a0$var$getSkeletonLines = (lineCount)=>{
    const skeletonLines = [];
    for(let i = 0; i < lineCount; i++)skeletonLines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$SkeletonLine, {
        key: `skeleton-line-${i}`
    }));
    return skeletonLines;
};
const $f8bed93993cee5a0$export$8f31e4c4a37b8e9c = (props)=>{
    const { lineCount: lineCount = 5 } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$AutomationSkeletonContainer, null, $f8bed93993cee5a0$var$getSkeletonLines(lineCount));
};

});


//# sourceMappingURL=UnarchivePagesLoader.5bf69011.js.map
